import { Box, Breadcrumbs, Card, CardContent, CardMedia, CircularProgress, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap';
// import AmbeintTempTab from './ambientTabContent/AmbeintTempTab';
import TabContent from '../../../../../components/TabContent';
import { WmcContext } from '../../../../../context/WmcContext';
import { DATA_TYPE, PASS_KEY, WEB_KEY } from '../../../../../api/AxiosApi';
import { getDateTimeForTab2, getGraphDateTime } from '../../../../../utils';
import { AuthenticationContext } from '../../../../../context/AuthenticationContext';

function TransformerHealthTab2() {
    const { spacing, breakpoints, palette } = useTheme()
    const { getWmSENS, GoToBottom, MenuLoadingTrans, getTabWmcMenuTransForm, getWmcDash, MenuItemsTrans, WmcLoading,MenuItems2 } = useContext(WmcContext)
    const { LoggedInUserInfo } = useContext(AuthenticationContext)
    // const LOC_CODE = LoggedInUserInfo?.Loc_Code
    const LOGIN_ID = sessionStorage.getItem('LoginID')
    const LOC_CODE = sessionStorage.getItem('LCODE')
    // const LOGIN_ID = sessionStorage.getItem('LoginID')
    const lgs = useMediaQuery(breakpoints.up('lg'))
    const [FromDate, setFromDate] = useState(getDateTimeForTab2().LastDay)
    const [ToDate, setToDate] = useState(getDateTimeForTab2().Today)
    const [key, setKey] = useState('');
    const DTYPE = "TRN";


    useEffect(() => {
        // Set the activeKey to the ID of the first item in PvMnMenuData
        if (MenuItemsTrans && MenuItemsTrans?.length > 0) {
            setKey(MenuItemsTrans[0]?.MENU_ID);
        }
    }, [MenuItemsTrans]);

    function handleClick(event) {
        event.preventDefault();
        // console.info('You clicked a breadcrumb.');
    }


    const WM_TYPE = key
    // console.log('Start', StartDate, EndDate)
    const PASS_KEY1 = "WERRRRRRRRRRR"

    useEffect(() => {
        getTabWmcMenuTransForm(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY,DTYPE)
    }, [])

    useEffect(() => {
        getWmSENS(LOC_CODE, LOGIN_ID, PASS_KEY1, WEB_KEY, WM_TYPE, FromDate, ToDate)
    }, [key])

    useEffect(() => {
        getWmcDash(LOC_CODE, LOGIN_ID, PASS_KEY1, WEB_KEY, WM_TYPE, DATA_TYPE, FromDate, ToDate)
    }, [key])

    const messageRef = useRef();

    useEffect(() => {
        setTimeout(() => {
            if (messageRef.current) {
                // alert('ok')
                messageRef.current.scrollIntoView(
                    {
                        behavior: 'smooth',
                        block: 'end',
                        inline: 'nearest'
                    })
            }
        }, 300) 
    }, [GoToBottom])

    return (
        <>
            <CssBaseline />
            <Box mt={spacing(1)}>
                {
                    MenuItemsTrans?.length > 0 ?
                        <Tabs

                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => setKey(k)}
                        >
                            {
                                MenuLoadingTrans ? <CircularProgress /> : MenuItemsTrans?.length > 0 ? MenuItemsTrans?.map((item, index) => {

                                    const matchedMenuItem = MenuItems2.find(menuItem => menuItem?.MENU_NAME === item?.MENU_NAME);
                                    return (
                                        <Tab key={index} eventKey={item?.MENU_ID} title={item?.MENU_NAME}>
                                            <TabContent WM_TYPE={WM_TYPE} tabTitle={item?.MENU_NAME} menuID={item?.MENU_ID} menuItem={matchedMenuItem?.SH_NAME_LOG || ''} />
                                        </Tab>
                                    )
                                }) : <Typography>Menu not found</Typography>
                            }
                        </Tabs>
                        : <Typography variant='body2' width={'100%'} textAlign={'center'}>Data not found</Typography>
                }

                <div ref={messageRef}></div>
            </Box>
        </>
    )
}

export default TransformerHealthTab2



